module.exports = new __parcel__URL__("google-chrome.48a91859.png").toString();